import React, { useEffect, useState } from 'react';

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Ingredient } from '../../services/api/models';
import { DragDropContext, Droppable, DropResult, DroppableProps } from 'react-beautiful-dnd'
import { IngredientEditRow } from '../IngredientEditRow';
import { IngredientAddRow } from '../IngredientAddRow';
import { useFieldArray, useFormContext } from 'react-hook-form';

const resetSort = (list: Array<Ingredient>) => {
  for (let i = 0; i < list.length; i++) {
    list[i].sort = i + 1
  }
}

interface CategorySelectorProps{
  showSort?: boolean;
}


export default function IngredientsEditTable(props: CategorySelectorProps) {
  const { control, getValues, setValue } = useFormContext();
  const { fields, move, remove } = useFieldArray({
    control,
    name: 'ingredients',
  });

  const onDragEnd = (result: DropResult) =>  {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    move(result.source.index, result.destination.index)

    const ingredients = getValues('ingredients');
    // update sort order
    resetSort(ingredients);
    setValue('ingredients', ingredients);
  }

  const onAddHandler = (ingredient: Ingredient) => {
    const ingredients = getValues('ingredients');
    const results = [...ingredients, ingredient];
    ingredient.sort = results.length;
    setValue('ingredients', results);
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="ingredients table">
        <TableHead>
          <TableRow>
            <TableCell align='left' sx={{padding: 0, width: 0}}></TableCell>
            <TableCell align='left'>Amount</TableCell>
            <TableCell align='left'>Unit</TableCell>
            <TableCell align='left'>Ingredient</TableCell>
            { props.showSort &&
              <TableCell align='left'>Sort</TableCell>
            }
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>
        <DragDropContext onDragEnd={onDragEnd}>
          <StrictModeDroppable droppableId='list' direction='vertical'>
            {provided => (
              <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                {fields.map((item, index) => (
                  <IngredientEditRow
                    index={index}
                    key={item.id}
                    showSort={props.showSort}
                    remove={remove}
                  />
                ))}
                {provided.placeholder}
                <IngredientAddRow
                  showSort={props.showSort}
                  onAdd={onAddHandler}
                />
              </TableBody>
            )}
          </StrictModeDroppable>
        </DragDropContext>
      </Table>
    </TableContainer>
  );
}


export const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  if (!enabled) {
    return null;
  }
  return <Droppable {...props}>{children}</Droppable>;
};
